<template>
  <div class="providers">
    <div v-for="provider in providers" :key="provider.provider_id" class="provider">
      <img v-if="provider[0].provider_id" :src="provider[0].provider_id | providerIcon" class="providers--icon" />
      <div v-if="showOffers">
        <div v-for="offer in provider" :key="offer.id" class="provider--offer">
          <div class="tag">{{ offer.monetization_type | toUpperCase }}</div>
          <div v-if="offer.retail_price" class="provider--offer--price">{{ offer.retail_price }} kr</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import providers from '../../public/mocks/providers.json';

export default {
  name: 'Providers',
  props: {
    providers: {
      type: Array,
      default: () => [],
    },
    showOffers: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    providerIcon: value => {
      const provider = providers.find(provider => provider.id === value);
      return `/images/${provider.slug}.png`;
    },
    toUpperCase: value => {
      return value.toUpperCase();
    },
  },
};
</script>

<style lang="scss">
.providers {
  display: flex;
  flex-wrap: wrap;
  .provider {
    margin-left: 16px;
    max-width: 50px;
    .providers--icon {
      max-width: 100%;
      box-shadow: 0px 0px 54px -7px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
    }
    .provider--offer {
      display: flex;
      margin-bottom: 6px;

      .tag {
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        margin-right: 4px;
        padding: 4px 8px;
        color: white;
        min-width: 50px;
        text-align: center;
        background-image: linear-gradient(-60deg, #ff5858 0%, #f09819 100%);
      }
    }
  }
}
</style>
